import { render, staticRenderFns } from "./region.vue?vue&type=template&id=0229ac47&scoped=true"
import script from "./region.vue?vue&type=script&lang=ts"
export * from "./region.vue?vue&type=script&lang=ts"
import style0 from "./region.vue?vue&type=style&index=0&id=0229ac47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0229ac47",
  null
  
)

export default component.exports